import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { doc, getDoc } from 'firebase/firestore';
import { db, auth, dataStore } from './app.component';
import { inject } from '@angular/core';
import { Role } from './enums';
import { environment } from 'src/environments/environment';

export const redirectUnauthorized: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const router: Router = inject(Router);
  const authorizedRights: Role[] = route.data.authorizedRights ?? [];

  const authUser: any = await new Promise((resolve) => {
    auth.onAuthStateChanged((user) => resolve(user));
  });

  if (!authUser?.uid) {
    return router.parseUrl('login');
  }

  const rootUser = dataStore?.rootUser ?? (await getDoc(doc(db, `users/${authUser.uid}`))).data();

  if (rootUser) {
    // Super User check (rights === 'admin')
    if (rootUser.rights && rootUser.rights === 'admin') {
      return true;
    }

    const orgUser =
      dataStore?.orgUser ??
      (
        await getDoc(doc(db, `organisations/${rootUser.selectedOrgId}/users/${authUser.uid}`))
      ).data();

    if (orgUser && orgUser.roles) {
      const roles: Role[] = orgUser.roles;

      const hasAccess = roles.some((role) => authorizedRights.includes(role));

      if (hasAccess) {
        return true;
      }
    }
  }
  return route.data.redirectTo ? router.parseUrl(route.data.redirectTo) : false;
};

export const redirectLoggedIn: CanActivateFn = async () => {
  const router: Router = inject(Router);
  const authUser: any = await new Promise((resolve) => {
    auth.onAuthStateChanged((user) => resolve(user));
  });
  console.log('Guard UID', authUser ? authUser.uid : 'No user logged in');
  return authUser ? router.parseUrl(environment.defaultRoute.id) : true;
};

export const redirectToLogin: CanActivateFn = async () => {
  const router: Router = inject(Router);
  const authUser: any = await new Promise((resolve) => {
    auth.onAuthStateChanged((user) => resolve(user));
  });
  console.log('Guard UID', authUser ? authUser.uid : 'No user logged in');
  return authUser ? true : router.parseUrl('auth');
};
